import { render, staticRenderFns } from "./VTour.vue?vue&type=template&id=d6ecde06"
import script from "./VTour.vue?vue&type=script&lang=js"
export * from "./VTour.vue?vue&type=script&lang=js"
import style0 from "./VTour.vue?vue&type=style&index=0&id=d6ecde06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports